<template>
    <CHeader data-aos-easing="linear" data-aos-duration="1500" id="el" class="navbars">
        <CHeaderBrand class="mx-auto" to="/index">
            <img src="../assets/img/Logo(1).png" height="32" class="m-2" alt="Interviewrr.ai company logo"/> <span class="custom-20px-500">Interviewrr</span>
        </CHeaderBrand>
    
        <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
            <template #toggler-content>
                                  <CIcon name="cil-justify-center" />
</template>
       
        <CDropdownItem href="https://interviewrr.ai/"
          >HOME</CDropdownItem
        >

        <CDropdownItem to="/HowItWork"
          >HOW IT WORKS</CDropdownItem
        >

        <CDropdownItem to="/About"
          >ABOUT US</CDropdownItem
        >

        <CDropdownItem to="/Blog"
          >BLOG</CDropdownItem
        >

        <CDropdown style="margin-left:7px">
<template #toggler-content>
     PLAN
</template>
        <CDropdownItem
          to="PlanIndividual"
          >CANDIDATE</CDropdownItem
        >
        <CDropdownItem
          to="PlanCompany"
          >COMPANY</CDropdownItem
        >
       
      </CDropdown>

      <CDropdownItem to="/Login"
          >PROFILE/LOGIN</CDropdownItem
        >

        <CDropdownItem to="/Faq"
          >FAQ</CDropdownItem
        >

      

        <CDropdownItem to="/ContactUs"
          >CONTACT US</CDropdownItem
        >

        <!-- <CDropdownItem to="/LogIn"
          >LOG IN</CDropdownItem
        > -->


        <CDropdownItem to="/JoinUs"
          >GET STARTED</CDropdownItem
        >

      

      </CDropdown>
  
      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
            color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/"
          >
            Home
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
               color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/HowItWork"
          >
           How It Works
          </CHeaderNavLink>
        </CHeaderNavItem>


        <CDropdown style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            ">
<template #toggler-content>
    <label style="
                                  color: #171717;font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 24px;  margin-top:9px;">About Us</label>
</template>
        <CDropdownItem
          to="About"
          >About</CDropdownItem
        >
        <CDropdownItem
          to="Blog"
          >Blog</CDropdownItem
        >

        <CDropdownItem
          to="ContactUs"
          >ContactUs</CDropdownItem
        >
       
      </CDropdown>
      

       

       

      

        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/Faq"
          >
            FAQ
          </CHeaderNavLink>
        </CHeaderNavItem>


        <CDropdown style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            ">
<template #toggler-content>
    <label style="
                                  color: #171717;font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 24px;  margin-top:9px;">Plan</label>
</template>
        <CDropdownItem
          to="PlanIndividual"
          >Candidate</CDropdownItem
        >
        <CDropdownItem
          to="PlanCompany"
          >Company</CDropdownItem
        >
       
      </CDropdown>

      <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/Login"
          >
            Profile/Login
          </CHeaderNavLink>
        </CHeaderNavItem>


        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
          style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
              margin-top:-9px;
            "
            to="/JoinUs"
          >
           <CButton class="border-171717"><span class="ml-2 mr-2" style="
              color: #171717;font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;">Get Started</span></CButton>
          </CHeaderNavLink>
        </CHeaderNavItem>

      

     

  
      </CHeaderNav>
    </CHeader>
  </template>
      
<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
    name: "TheHeader",
    components: {
        TheHeaderDropdownAccnt,
    },
    data() {
        return {
          Name: "",
          user: {}
        }
    },
    async mounted() {

         //this.GetInfoUser();

        if (localStorage.getItem("reloaded")) {
            // The page was just reloaded. Clear the value from local storage
            // so that it will reload the next time this page is visited.
            localStorage.removeItem("reloaded");
        } else {
            // Set a flag so that we know not to reload the page twice.
            localStorage.setItem("reloaded", "1");
            location.reload();
        }
    },
    methods: {


        GoToLogin() {
            this.router.push("Login");
        },
      
    },
};
</script>

<style scoped>

</style>
  
  
  